<template>
  <div>
    <page-toolbar>
      <kendo-button icon="add" title="Add new" @click="addRecord" v-if="!isReadOnly">
      </kendo-button>
      <kendo-dropdownlist
        v-model="sendingMessageReportId"
        :data-source="sendingMessageReportDataSource"
        :data-text-field="'sendingMessageReportName'"
        :data-value-field="'sendingMessageReportId'"
        @change="sendingMessageReportDropDownListChange"
      ></kendo-dropdownlist>
      <kendo-dropdownlist
        v-model="languageId"
        :data-source="languageDataSource"
        :data-text-field="'languageName'"
        :data-value-field="'languageId'"
        @change="languageDropDownListChange"
        style="width:100px"
      ></kendo-dropdownlist>
    </page-toolbar>
    <div style="height:calc(100vh - 182px)" ref="sendTextGrid"></div>
  </div>
</template>
<script>
import $ from '../../helpers/jquery-bridge'
import PageToolbar from '@/components/PageToolbar'
import {enableExportExcel} from '../../helpers/export-helper'
import {getDataItem} from '@/helpers/kendo-helpers'
import {jsonDropDownEditor, readOnlyEditor} from '../../helpers/kendo-editors'
import security from '@/mixins/security'
import {mapGetters} from 'vuex'

export default {
  mixins: [security],
  components: {
    PageToolbar,
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  data() {
    return {
      sendingMessageReportId: -1,
      sendingMessageReportDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/config/detOtherText/GetSendingMessageReports?addAll=true',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
      languageId: -1,
      languageDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/config/sendingMessage/getLanguages?addAll=true',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
    }
  },
  mounted() {
    let vm = this
    let grid = $(vm.$refs.sendTextGrid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 16,
          transport: {
            create: {
              type: 'POST',
              url: '/api/config/detOtherText',
              dataType: 'json',
            },
            read: {
              type: 'GET',
              url: '/api/config/detOtherText',
              dataType: 'json',
              data: () => {
                return {
                  sendingMessageReportId: vm.sendingMessageReportId,
                  languageId: vm.languageId,
                  clientId: vm.clientId,
                }
              },
            },
            update: {
              type: 'PUT',
              url: '/api/config/detOtherText',
              dataType: 'json',
            },
            destroy: {
              type: 'DELETE',
              url: '/api/config/detOtherText',
              dataType: 'json',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'detOtherTextId',
              fields: {
                detOtherTextId: {type: 'number', validation: {required: true}},
                sendingMessageReportId: {type: 'number', validation: {required: true}},
                sendingMessageReportName: {type: 'string', validation: {required: true}},
                clientId: {type: 'number', validation: {required: true}},
                clientName: {type: 'string', validation: {required: true}},
                languageId: {type: 'number', validation: {required: true}, defaultValue: 1},
                languageName: {type: 'string', validation: {required: true}},
                description: {type: 'string', validation: {required: true}},
                paramId: {type: 'number'},
                paramName: {type: 'string'},
                canDelete: {type: 'boolean', defaultValue: true},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              e.preventDefault()
            })
          },
        }),
        editable: !vm.isReadOnly && 'inline',
        filterable: true,
        sortable: true,
        pageable: true,
        columns: [
          {
            command: [{name: 'edit'}],
            width: 64,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {
            field: 'sendingMessageReportName',
            title: 'Report',
            width: 182,
            editor: function(container, options) {
              const sendingMessageId = options.model.sendingMessageId
              if (sendingMessageId != 1) {
                return jsonDropDownEditor(
                  'sendingMessageReportId',
                  'sendingMessageReportName',
                  '/api/config/detOtherText/GetSendingMessageReports?allAll=false',
                  {
                    change: e => {
                      let rowItem = getDataItem(e.sender.element)
                      rowItem.set('sendingMessageReportName', e.sender.text())
                    },
                    dataBound: function(e) {
                      let rowItem = getDataItem(e.sender.element)
                      if (rowItem.sendingMessageId == 0) this.select(0)
                      this.trigger('change')
                    },
                  },
                ).call(this, container, options)
              } else {
                return readOnlyEditor.call(this, container, options)
              }
            },
          },
          {
            field: 'clientName',
            title: 'Client',
            width: 182,
            template: '#=clientName#',
            editor: function(container, options) {
              const getClientsUrl = `/api/config/detOtherText/getClients?clientId=${vm.clientId}`
              return jsonDropDownEditor('clientId', 'clientName', getClientsUrl, {
                change: e => {
                  let rowItem = getDataItem(e.sender.element)
                  rowItem.set('clientName', e.sender.text())
                },
                dataBound: function(e) {
                  let rowItem = getDataItem(e.sender.element)
                  if (rowItem.sendingMessageId == 0) this.select(0)
                  this.trigger('change')
                },
                filter: 'contains',
              }).call(this, container, options)
            },
          },
          {
            field: 'languageName',
            title: 'Language',
            width: 120,
            editor: function(container, options) {
              return jsonDropDownEditor('languageId', 'languageName', '', {
                dataSource: {
                  transport: {
                    read: {
                      url: '/api/config/detOtherText/GetLanguages',
                      contentType: 'application/json',
                      type: 'GET',
                    },
                  },
                },
              }).call(this, container, options)
            },
          },
          {
            field: 'description',
            title: 'Text',
            width: 332,
          },
          {
            field: 'paramName',
            title: 'Param',
            width: 120,
            editor: function(container, options) {
              return jsonDropDownEditor('paramId', 'paramName', '', {
                dataSource: {
                  transport: {
                    read: {
                      url: '/api/config/detOtherText/GetParams',
                      contentType: 'application/json',
                      type: 'GET',
                    },
                  },
                },
              }).call(this, container, options)
            },
          },
          {
            command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
            width: 64,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {},
        ],
      })
      .getKendoGrid()

    enableExportExcel(grid, '/api/config/detOtherText/exportToExcel', $('.page_toolbar-item'))
  },
  methods: {
    addRecord() {
      let grid = $(this.$refs.sendTextGrid).getKendoGrid()
      grid.addRow()
    },
    sendingMessageReportDropDownListChange(e) {
      this.sendingMessageReportId = +e.sender.value()
      this.refreshGrid()
    },
    languageDropDownListChange(e) {
      this.languageId = +e.sender.value()
      this.refreshGrid()
    },
    refreshGrid() {
      let grid = $(this.$refs.sendTextGrid).getKendoGrid()
      return grid.dataSource.read()
    },
  },
}
</script>
